











import { defineComponent } from '@nuxtjs/composition-api';
import AppOptimizedImage from '~/components/partials/App/AppOptimizedImage.vue';

export default defineComponent({
  components: {
    AppOptimizedImage,
  },
  props: {
    src: {
      type: String,
      default: require('~/assets/svg/icon_people.svg'),
    },
    alt: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: '60px',
    },
  },
});
